import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'

import { Comment as PostCommentsModel } from '@/models/Posts'
import fetchPostComments from '@/utils/api/fetchPostComments'
import { fixNextPageUrl } from '@/utils/helper'

const requiredPageSize = 2

const useComments = (id?: number) => {
  const [comments, setcomments] = useState<PostCommentsModel[]>([])
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [loadingNext, setLoadingNext] = useState(false)
  const [error, setError] = useState('')

  const { locale } = useRouter()

  //To fetch the new comment without refresh, remove the last comment if nextPageURL is present and insert new comment at first position
  const fetchNewComment = useCallback(
    async (newComment: PostCommentsModel) => {
      if (comments) {
        setLoadingNext(true)
        if (nextPageUrl) comments.pop()
        comments.unshift(newComment)
        setLoadingNext(false)
      }
    },
    [comments, nextPageUrl]
  )

  const fetchNext = useCallback(async () => {
    if (nextPageUrl) {
      setLoadingNext(true)
      const response = await fetchPostComments(nextPageUrl)
      if (response) {
        const { results, next } = response
        setcomments((prev) => prev.concat(...results))
        setNextPageUrl(fixNextPageUrl(next) || null)
        setError('')
      } else {
        //TODO:: handle rejection
        setError('unable_to_fetch_more_data_caption')
      }
      setLoadingNext(false)
    }
  }, [nextPageUrl])

  const getComments = useCallback(async () => {
    setLoading(true)
    const url = `/community/v2/posts/${id}/comments`
    const response = await fetchPostComments(url, {
      lang: locale,
      page: 1,
      page_size: requiredPageSize,
    })
    if (response) {
      const { results, next } = response
      setcomments(results)
      setNextPageUrl(fixNextPageUrl(next) || null)
      setError('')
    } else {
      //TODO:: Handle rejection
      setError('unable_to_fetch_data_caption')
    }
    setLoading(false)
  }, [locale, id])

  useEffect(() => {
    if (id) getComments()
  }, [id, getComments])

  return {
    fetchNext,
    loading,
    loadingNext,
    comments,
    nextPageUrl,
    error,
    getComments,
    fetchNewComment,
  }
}

export default useComments
